export const allMediaTypes = ['image', 'audio', 'video', 'other'] as const

export type MediaType = typeof allMediaTypes[number]
